/* eslint-ignore */
// @ts-nocheck
import { Field as FormikField, Formik } from 'formik';
import moment from 'moment';
import React, { Component } from 'react';
import { Form as BootstrapForm } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import DatePickerField from '~/components/layout/form/DatePickerField';
import TextField from '~/components/layout/form/textField';
import {
  CalendarIcon,
  CancelButtonContainer,
  CloseIcon,
  Container,
  Content,
  CurrencyField,
  DateContainer,
  FilterButtonContainer,
  FilterButtonText,
  Header,
  Label,
  Left,
  NumberContainer,
  PeriodCircle,
  PeriodContainer,
  PeriodItem,
  PeriodText,
  Separator,
  Title,
  ValueContainer,
} from './styles';

class ModalFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      beginDate: '',
      endDate: '',
      beginAmount: '',
      endAmount: '',
      invoiceNumber: '',
      selectedPeriodo: null,
      disabledDateField: false,
      dateError: false,
    };
  }

  async componentDidMount() {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const status = await params.get('status');
    if (status) this.setState({ status });
  }

  handlePeriodo = (dias) => {
    const { selectedPeriodo, status } = this.state;
    const beginDate = new Date();
    const endDate = new Date();

    beginDate.setDate(beginDate.getDate() - dias);

    if (selectedPeriodo === dias) {
      this.setState({ selectedPeriodo: null, beginDate: null, endDate: null });
    }
    if (selectedPeriodo != dias) {
      this.setState({ selectedPeriodo: dias });
      this.setState({ beginDate, endDate });
    }
  };

  handleSubmit = () => {
    let { beginDate, endDate, invoiceNumber, beginAmount, endAmount } =
      this.state;

    let errorBeginDate = false;
    let errorEndDate = false;
    let errorBeginAmount = false;
    let errorEndAmount = false;

    if (beginDate && endDate != '') {
      beginDate = moment(beginDate).format('DD-MM-YYYY');
      endDate = moment(endDate).format('DD-MM-YYYY');
    }

    if (beginDate) {
      if (beginDate.length === 10) {
        const beginDay = beginDate.substring(0, 2);
        const beginMonth = beginDate.substring(3, 5);
        const beginYear = beginDate.substring(6, 10);
        beginDate = `${beginYear}-${beginMonth}-${beginDay}`;
        errorBeginDate = false;
      } else if (beginDate.length >= 11) {
        errorBeginDate = true;
        toast.error('Informe uma data inicial válida');
      }
    }

    if (endDate) {
      if (endDate.length === 10) {
        const endDay = endDate.substring(0, 2);
        const endMonth = endDate.substring(3, 5);
        const endYear = endDate.substring(6, 10);
        endDate = `${endYear}-${endMonth}-${endDay}`;
        errorEndDate = false;
      } else if (endDate.length >= 11) {
        errorEndDate = true;
        toast.error('Informe uma data final válida');
      }
    }

    if (beginDate && !endDate) toast.error('Data final é obrigatória!');
    if (!beginDate && endDate) toast.error('Data inicial é obrigatória!');

    if (beginAmount && !endAmount) {
      toast.error('Valor máximo é obrigatório!');
      errorEndAmount = true;
    } else if (!beginAmount && endAmount) {
      toast.error('Valor minimo é obrigatório!');
      errorBeginAmount = true;
    } else if (beginAmount && beginAmount) {
      if (endAmount < beginAmount) {
        toast.error('Valor máximo deve ser maior que o minimo!');
        errorEndAmount = true;
      }
    }

    if (beginDate === null) beginDate = '';
    if (endDate === null) endDate = '';
    if (beginAmount === 0) beginAmount = '';
    if (endAmount === 0) endAmount = '';

    if (
      !errorBeginAmount &&
      !errorEndAmount &&
      !errorBeginDate &&
      !errorEndDate
    ) {
      // Verifica se tem só data
      if (beginDate && endDate && invoiceNumber === '' && beginAmount === '')
        window.location = `/notas?begin-date=${beginDate}&end-date=${endDate}`;

      // Verifica se tem nº da nota e data
      if (invoiceNumber && beginDate && endDate && beginAmount === '') {
        window.location = `/notas?begin-date=${beginDate}&end-date=${endDate}&invoice-number=${invoiceNumber}`;
      }

      // Verifica se tem valor da nota e data
      if (
        beginAmount &&
        endAmount &&
        beginDate &&
        endDate &&
        invoiceNumber === ''
      ) {
        window.location = `/notas?begin-date=${beginDate}&end-date=${endDate}&begin-amount=${beginAmount}&end-amount=${endAmount}`;
      }

      // Verifica se tem valor da nota, numero da nota e data
      if (beginAmount && endAmount && invoiceNumber && beginDate && endDate) {
        window.location = `/notas?begin-date=${beginDate}&end-date=${endDate}&begin-amount=${beginAmount}&end-amount=${endAmount}&invoice-number=${invoiceNumber}`;
      }

      // Verifica se tem valor da nota e numero da nota
      if (
        beginAmount &&
        endAmount &&
        invoiceNumber &&
        beginDate === '' &&
        endDate === ''
      ) {
        window.location = `/notas?&begin-amount=${beginAmount}&end-amount=${endAmount}&invoice-number=${invoiceNumber}`;
      }

      // Verifica se tem valor da nota
      if (
        beginAmount &&
        endAmount &&
        invoiceNumber === '' &&
        beginDate === '' &&
        endDate === ''
      ) {
        window.location = `/notas?begin-amount=${beginAmount}&end-amount=${endAmount}`;
      }

      // Verifica se tem numero da nota
      if (
        invoiceNumber &&
        beginAmount === '' &&
        endAmount === '' &&
        beginDate === '' &&
        endDate === ''
      ) {
        window.location = `/notas?invoice-number=${invoiceNumber}`;
      }

      if (
        !beginDate &&
        !endDate &&
        !beginAmount &&
        !endAmount &&
        !invoiceNumber
      )
        window.location = `/notas`;
    }
  };

  validationInvoiceNumber = (e, handleChange) => {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, '');
    event.target.value = event.target.value.replace(/[^\d]/g, '');
    if (numbers.length === 30) {
      event.target.value = numbers;
    }
    this.setState({ invoiceNumber: event.target.value });
    handleChange(event);
  };

  handlebeginAmount = (event, maskedvalue, floatvalue) => {
    this.setState({
      invoiceValueMinInput: maskedvalue,
      beginAmount: floatvalue,
    });
    if (floatvalue === 0)
      this.setState({ invoiceValueMaxInput: 0.0, endAmount: 0.0 });
  };

  handleendAmount = (event, maskedvalue, floatvalue) => {
    this.setState({
      invoiceValueMaxInput: maskedvalue,
      endAmount: floatvalue,
    });
  };

  render() {
    const { close } = this.props;
    const FilterSchema = Yup.object().shape({});
    const { beginDate, endDate, status, selectedPeriodo } = this.state;
    return (
      <Container>
        <Header>
          <Left>
            <Title>Filtrar</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          <Label>Período</Label>
          <PeriodContainer>
            <PeriodItem
              selected={selectedPeriodo === 15}
              onClick={() => this.handlePeriodo(15)}
            >
              <PeriodCircle selected={selectedPeriodo === 15} />
              <PeriodText>Últimos 15 dias</PeriodText>
            </PeriodItem>
            <PeriodItem
              selected={selectedPeriodo === 30}
              onClick={() => this.handlePeriodo(30)}
            >
              <PeriodCircle selected={selectedPeriodo === 30} />
              <PeriodText>Últimos 30 dias</PeriodText>
            </PeriodItem>
            <PeriodItem
              selected={selectedPeriodo === 60}
              onClick={() => this.handlePeriodo(60)}
            >
              <PeriodCircle selected={selectedPeriodo === 60} />
              <PeriodText>Últimos 60 dias</PeriodText>
            </PeriodItem>
            <PeriodItem
              selected={selectedPeriodo === 90}
              onClick={() => this.handlePeriodo(90)}
            >
              <PeriodCircle selected={selectedPeriodo === 90} />
              <PeriodText>Últimos 90 dias</PeriodText>
            </PeriodItem>
          </PeriodContainer>
          <Separator />
          <Formik
            validationSchema={FilterSchema}
            render={() => (
              <DateContainer>
                <BootstrapForm.Group controlId="beginDate">
                  <FormikField
                    render={({ field }) => {
                      return (
                        <>
                          <Label>Data inicial</Label>
                          <DatePickerField
                            onChange={(date) =>
                              this.setState({
                                beginDate: date,
                                selectedPeriodo: null,
                              })}
                            selected={beginDate}
                            TrailingIcon={() => (
                              <CalendarIcon className="mdi mdi-calendar-blank-outline" />
                            )}
                            styles={{
                              container: { width: '100%', height: '40px' },
                            }}
                            placeholderText="--/--/----"
                          />
                        </>
                      );
                    }}
                    name="beginDate"
                  />
                </BootstrapForm.Group>
                <BootstrapForm.Group controlId="endDate">
                  <FormikField
                    render={({ field }) => {
                      return (
                        <>
                          <Label>Data final</Label>
                          <DatePickerField
                            onChange={(date) =>
                              this.setState({
                                endDate: date,
                                selectedPeriodo: null,
                              })}
                            selected={endDate}
                            disabled={beginDate === ''}
                            minDate={new Date(beginDate)}
                            TrailingIcon={() => (
                              <CalendarIcon className="mdi mdi-calendar-blank-outline" />
                            )}
                            styles={{
                              container: { width: '100%', height: '40px' },
                            }}
                            placeholderText="--/--/----"
                          />
                        </>
                      );
                    }}
                    name="endDate"
                  />
                </BootstrapForm.Group>
              </DateContainer>
            )}
          />

          <Separator />

          <Formik
            validationSchema={FilterSchema}
            render={() => (
              <ValueContainer>
                <BootstrapForm.Group controlId="valor">
                  <FormikField
                    render={({ field }) => {
                      return (
                        <>
                          <Label>Valor min.</Label>
                          <CurrencyField
                            value={this.state.invoiceValueMinInput}
                            onChangeEvent={this.handlebeginAmount}
                          />
                        </>
                      );
                    }}
                    name="valor"
                  />
                </BootstrapForm.Group>
                <BootstrapForm.Group controlId="valor">
                  <FormikField
                    render={({ field }) => {
                      return (
                        <>
                          <Label>Valor max.</Label>
                          <CurrencyField
                            disabled={!this.state.beginAmount}
                            style={{
                              backgroundColor: this.state.beginAmount
                                ? '#f1f9ff'
                                : '#f0f0f0',
                            }}
                            value={
                              this.state.beginAmount
                                ? this.state.invoiceValueMaxInput
                                : 0.0
                            }
                            onChangeEvent={this.handleendAmount}
                          />
                        </>
                      );
                    }}
                    name="valor"
                  />
                </BootstrapForm.Group>
              </ValueContainer>
            )}
          />

          <Separator />

          <Formik
            validationSchema={FilterSchema}
            render={({
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <NumberContainer>
                <BootstrapForm.Group controlId="endDate">
                  <FormikField
                    render={({ field }) => {
                      return (
                        <>
                          <Label>Nº da Nota</Label>
                          <TextField
                            {...field}
                            type="text"
                            ariaLabel="Nº da Nota"
                            ariaRequired
                            errorCondition={errors.nota && touched.nota}
                            errorMessage={errors.nota}
                            title="Nº da Nota"
                            onBlur={handleBlur}
                            placeholder="Nº da Nota"
                            value={values?.nota}
                            onChange={(e) => {
                              this.validationInvoiceNumber(e, handleChange);
                            }}
                          />
                        </>
                      );
                    }}
                    name="endDate"
                  />
                </BootstrapForm.Group>
              </NumberContainer>
            )}
          />

          <Separator />

          <DateContainer>
            <CancelButtonContainer onClick={close}>
              <FilterButtonText>Cancelar</FilterButtonText>
            </CancelButtonContainer>
            <FilterButtonContainer
              onClick={() => this.handleSubmit()}
              type="submit"
            >
              <FilterButtonText>Filtrar</FilterButtonText>
            </FilterButtonContainer>
          </DateContainer>
        </Content>
      </Container>
    );
  }
}

export default ModalFilter;
